import { conversationalSearchConnector } from '../../conversational-search-logic/connector/connector';
import type { ConversationalSearchAnswer, ConversationalSearchMessages, ConversationalSearchQuestion } from '../../conversational-search-types/conversational-search-types.type';
import type { ConversationalSearchMessagesMediatorsWrapper } from './mediators-wrapper';
import dynamicBannerStore from '../../conversational-search-banners/dynamic/dynamic-banner-mediator/dynamic-banner-store';
import { getChatActionSessionStorageValue, setChatActionSessionStorageValue } from '../../conversational-search-logic/storage-manager/storage-manager-helpers';
import { answerViewTypes } from '../../conversational-search-logic/utils/utils';

export const generateUserMessageObject = (query: string, type: string, action?: string) => ({
  action,
  query,
  type,
});

export const getCorrectObjectForFollowUpActions = (identifier: string, query: string) => {
    const type = `conversation/followup/${identifier}`;
    return [generateUserMessageObject(query, type, identifier)];
};

const updateProcessingState = (context: ConversationalSearchMessagesMediatorsWrapper, value: boolean) => {
    context.userPromptQuestionEventEmitter.emit({ isProcessing: value });
    context.procssing = value;
};

export const updateDynamicArray = (
  newData: (ConversationalSearchMessages | ConversationalSearchMessages[]) & ConversationalSearchQuestion,
  context: ConversationalSearchMessagesMediatorsWrapper
) => {
    if (!getChatActionSessionStorageValue()) setChatActionSessionStorageValue();
    context.isNewConversation = false;
    context.messagesUpdateEventEmitter.emit();
    updateProcessingState(context, false);
    if (Array.isArray(newData)) {
      newData.forEach(element => updateDynamicArray(element, context));
    } else {
      context.dynamicMessages.push(newData);
    }
};

const updateStorage = (data: ConversationalSearchMessages, dynamicMessages: ConversationalSearchMessages[], query: string) => {
    dynamicBannerStore.set('isRefinement', true);
    const isDataForPreviewAvailable = data?.results?.length;

    if (isDataForPreviewAvailable) {
      const lastUserMessage = [...dynamicMessages].reverse().find(message => message.isUserMessage)?.question;
      dynamicBannerStore.set('data', data);
      dynamicBannerStore.set('question', dynamicMessages.length === 1 ? query : lastUserMessage || query);
    }
};

export const newMessageHandler = async (query: string, context: ConversationalSearchMessagesMediatorsWrapper, isInitialQuestion = false) => {
    if (!isInitialQuestion) updateDynamicArray(generateUserMessageObject(query, answerViewTypes.UserMessage), context);
    updateProcessingState(context, true);

    const response = await conversationalSearchConnector(
      context.apigeeTokenUrl,
      context.apigeeAuth,
      context.conversationalSearchProductsEndpoint,
      query,
      context.language,
      context.country,
    );

    if (response?.detectedContext?.isFirstMessageInContext && context.dynamicMessages.length > 1) {
      context.contextChangedEventEmitter.emit();
    }

    updateDynamicArray(response as ConversationalSearchAnswer, context);
    updateStorage(response as ConversationalSearchAnswer, context.dynamicMessages, query);
};

export const handleDynamicBannerProcessing = (context: ConversationalSearchMessagesMediatorsWrapper) => {
    if (context.dynamicMessages?.length) return;
    const previewData = dynamicBannerStore.get('data');
    if (previewData) {
      updateDynamicArray(previewData, context);
    } else {
      updateProcessingState(context, true);
      context.bannerTimeout = setTimeout(() => {
          const previewData = dynamicBannerStore.get('data');
          if (previewData && !context.dynamicMessages.includes(previewData)) {
            updateDynamicArray(previewData, context);
            clearTimeout(context.bannerTimeout);
          } else {
            handleDynamicBannerProcessing(context);
          }
      }, 1000);
    }
};
